var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#5F5F5F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "9gf2cg08xa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#5F5F5F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9gf2cg08xa)",
    stroke: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.586 2.465 11.718 78.563M31.117-25.902-23.75 50.195M48.86-11.718-6.01 64.379M13.39-40.086l-54.867 76.097M57.719-4.626 2.85 71.47M22.258-32.994-32.61 43.103M39.984-18.81l-54.868 76.097M4.516-47.177-50.352 28.92M62.148-1.08 7.28 75.016M26.68-29.448-28.188 46.65M44.422-15.264l-54.868 76.097M8.953-43.631l-54.868 76.097M53.281-8.172-1.587 67.925M17.82-36.54l-54.868 76.097M35.555-22.355l-54.868 76.097M.094-50.724l-54.868 76.097M64.375.693 9.507 76.79M28.898-27.675l-54.867 76.097M46.64-13.49-8.226 62.605M11.164-41.859l-54.868 76.097M55.5-6.4.632 69.699M20.04-34.767-34.83 41.331M37.773-20.583l-54.868 76.097M2.297-48.95l-54.868 76.097M59.938-2.853 5.07 73.244M24.477-31.221l-54.868 76.097M42.203-17.037-12.665 59.06M6.734-45.405l-54.868 76.097M51.063-9.945-3.806 66.152M15.602-38.313l-54.868 76.098M33.336-24.129l-54.868 76.097"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.146396ac.svg";
export { ForwardRef as ReactComponent };